import {cloneElement} from 'react';
import root from 'window-or-global';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

export interface ElevationScrollProps {
    children: React.ReactElement;
}

const ElevationScroll = ({children}: ElevationScrollProps) => {
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: root.window || undefined
    });

    return cloneElement(children, {
        elevation: trigger ? 4 : 0
    });
};

export default ElevationScroll;
